import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import PDPInfoSectionLayout from './PDPInfoSectionLayout';

// Care tab: the cleaning list that today only exists inside the
// details-and-care full-screen modal
const PDPInfoCareSection = () => {
  const $ = _c(11);
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    data: t0
  } = useProductAttributes();
  const {
    productCareDetails
  } = t0;
  const name = basicDetails?.name ?? "";
  const t1 = `${name} Care`;
  let t2;
  if ($[0] !== t1) {
    t2 = t1.trim();
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== productCareDetails) {
    t3 = productCareDetails ?? [];
    $[2] = productCareDetails;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = t3.map(_temp);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <ul className="ml-0 pl-4">{t4}</ul>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <PDPInfoSectionLayout heading={t2}>{t5}</PDPInfoSectionLayout>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default PDPInfoCareSection;
function _temp(careItem) {
  return <li key={careItem} className="text-sm text-gray mb-4">{careItem}</li>;
}